import {SERVER_URL_CATALOGO} from "@/requests/common";
import {IServiceFilterOut} from "cdp-fe-commons-layout";

export class catalogoApi {
    public static GET_ALL_ALLEGATI_BY_CATALOGO_ID(id_catalogo: string | number): string {
        return `${SERVER_URL_CATALOGO}/allegato/search/findAllByCatalogoIdAndDataFineIsNull?catalogoId=${id_catalogo}`;
    }

    public static GET_ALL_ARGOMENTI(): string {
        return `${SERVER_URL_CATALOGO}/argomento`
    }

    public static GET_ALL_MATERIE(): string {
        return `${SERVER_URL_CATALOGO}/materie`
    }

    public static GET_ALL_ARGOMENTI_BY_MATERIA_ID(materiaId: number | string): string {
        return `${SERVER_URL_CATALOGO}/argomento/search/findAllByMaterieId?materieId=` + materiaId;
    }

    public static GET_ALL_DESTINATARI(): string {
        return `${SERVER_URL_CATALOGO}/destinatario`
    }

    public static GET_DESTINATARI_BY_CATALOGO_ID(): string {
        return `${SERVER_URL_CATALOGO}/catalogoDestinatari/search/findAllByCatalogoId`
    }

    public static GET_ALL_TIPOLOGIE(): string {
        return `${SERVER_URL_CATALOGO}/tipologia`
    }

    public static GET_ALL_CATALOGO_ISTANZE(page: number, limit: number, filters?: IServiceFilterOut): string {
        let url = `${SERVER_URL_CATALOGO}/catalogoIstanze/search/getActiveCatalogosWithFilters?page=${(page - 1)}&size=${limit}`
        url += filters?.text && filters?.text.length>0?`&testo=${filters?.text ?? ''}`:'';
        url += filters?.destinatari && filters?.destinatari.length>0 ? `&destinatari=${filters.destinatari.join(",")}` : ''
        url += filters?.argomento  ? `&argomenti=${filters.argomento}` : ''
        url += filters?.materia  ? `&materie=${filters.materia}` : ''
        url += filters?.tipologia  ? `&tipologie=${filters.tipologia}` : ''
        //url += '&categoriaTipologiaProcedimento=PI'
        return url;
    }

    public static GET_CATALOGO_ISTANZE_BY_CODICE(codiceCatalogo: string): string {
        return `${SERVER_URL_CATALOGO}/catalogoIstanze/search/getFirstByCodiceCdp?codice=${codiceCatalogo}`
    }

    public static GET_TITOLO_CATALOGO_ISTANZE_BY_CODICE_CATALOGO(codiceCatalogo: string): string {
        return `${SERVER_URL_CATALOGO}/catalogoIstanze/search/getFirstTitoloCatalogoByCodiceCdp?codice=${codiceCatalogo}`
    }

    public static FIND_BY_ID(catalogoId: string | number): string {
        return `${SERVER_URL_CATALOGO}/catalogoIstanze/${catalogoId}`
    }

    public static GET_ALL_MODULISTICA_BY_CATALOGO_ID(catalogoId: string | number): string {
        return `${SERVER_URL_CATALOGO}/modulistica/search/findAllByCatalogoId?catalogoId=${catalogoId}`
    }

    public static DOWNLOAD_MODULISTICA_BY_CATALOGO_ID(catalogoId: string | number): string {
        return `${SERVER_URL_CATALOGO}/catalogo/${catalogoId}/modulistica`
    }

    public static GET_ALLEGATO_INTEGRAZIONE(catalogoId: string | number, key: string): [string, any] {
        return [`${SERVER_URL_CATALOGO}/catalogo/allegati/integrazione`, {catalogoId: catalogoId, key: key}];
    }

    public static GET_ALLEGATO_ESENZIONE_PAGAMENTO(catalogoId: string|number, key: string, descrizione: string): [string, any]
    {
        return [`${SERVER_URL_CATALOGO}/catalogo/allegati/pagamenti/esenzione`, {catalogoId: catalogoId, key: key, descrizione: descrizione}];
    }
}
